export default {
  taskManagement: {},
};
